import React from "react";
import styled from "@emotion/styled";
import { Users } from "react-feather";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
  Typography,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { Association } from "../../redux/slices/association";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarAssociationDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<null | HTMLElement>(null);
  const { currentUser, changeAssociation } = useAuth(); // Assuming changeAssociation is a function in your useAuth hook

  // Check if currentUser and their associations exist before rendering
  if (
    !currentUser ||
    !currentUser.associations ||
    currentUser.associations.length <= 1
  ) {
    return null; // Don't render the dropdown if there's no user or only one association
  }

  const toggleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleAssociationChange = (association: Association) => {
    changeAssociation(association);
    closeMenu();
  };

  const isSelected = (associationId: string) => {
    return currentUser?.activeAssociation?.id === associationId;
  };

  return (
    <React.Fragment>
      <Tooltip title="Vaihda tiekunta">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "association-menu" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <Users />
        </IconButton>
      </Tooltip>
      <Menu
        id="association-menu"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <Typography
          variant="subtitle2"
          sx={{ px: 2, pt: 1, pb: 0.5, fontWeight: "bold" }}
        >
          Tiekunnat
        </Typography>
        {currentUser.associations.map((association: any) => (
          <MenuItem
            key={association.id}
            onClick={() => handleAssociationChange(association)}
            selected={isSelected(association.id)}
          >
            {association.name}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}

export default NavbarAssociationDropdown;
